import React from 'react';
import { ShieldCheck } from 'lucide-react';

/**
 * Privacy promise badge — used sitewide to counter-position vs ad-heavy competitors.
 * Variants: 'inline' (small chip), 'banner' (full strip), 'footer' (dark theme).
 */
export default function PrivacyBadge({ variant = 'inline', className = '' }) {
  if (variant === 'banner') {
    return (
      <div
        data-testid="privacy-banner"
        className={`flex items-center justify-center gap-2 px-4 py-2.5 bg-[#F4E4DA] border-y border-[#EBD3C2] text-[#5A4439] text-xs ${className}`}
      >
        <ShieldCheck className="w-4 h-4 text-[#7B2C3B]" />
        <span>
          <strong className="font-semibold">Privacy first.</strong> We will never sell your data — to vendors, advertisers, or anyone else. Promise.
        </span>
      </div>
    );
  }
  if (variant === 'footer') {
    return (
      <div
        data-testid="privacy-badge-footer"
        className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-[#5A4439] text-[#F4D6CE] text-xs ${className}`}
      >
        <ShieldCheck className="w-3.5 h-3.5" />
        We never sell your data
      </div>
    );
  }
  return (
    <div
      data-testid="privacy-badge"
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#F4E4DA] border border-[#EBD3C2] text-[#7B2C3B] text-xs font-medium ${className}`}
    >
      <ShieldCheck className="w-3.5 h-3.5" />
      We never sell your data
    </div>
  );
}
